import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';
import LowBalanceAlertModal from '../../../../components/modals/LowBalanceAlertModal';

const LowBalanceAlert = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const apiProviders = [
      'RupeeBiz API 1', 'RupeeBiz API 2', 'PayTM Gateway', 'Airtel Payment API', 
      'Jio Money API', 'Paytm Business', 'PhonePe API', 'Razorpay API',
      'Cashfree API', 'Instamojo API', 'BillDesk API', 'CCAvenue API'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      apiProvider: apiProviders[i % apiProviders.length],
      thresholdAmount: `₹${(1000 + (i * 500)).toFixed(2)}`,
      currentBalance: `₹${(15000 + (i * 1000)).toFixed(2)}`,
      mobile: `+91 ${9000000000 + i}`,
      email: `api${i + 1}@Shakti E Solution.com`
    }));
  };

  const [data, setData] = useState(generateSampleData(50));
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedAlert, setSelectedAlert] = useState(null);

  const handleAddAlert = () => {
    setModalMode('add');
    setSelectedAlert(null);
    setShowModal(true);
  };

  const handleEditAlert = (alert) => {
    setModalMode('edit');
    setSelectedAlert(alert);
    setShowModal(true);
  };

  const handleSaveAlert = (alertData) => {
    if (modalMode === 'add') {
      setData([...data, alertData]);
    } else {
      setData(data.map(item => 
        item.apiProvider === selectedAlert.apiProvider && item.mobile === selectedAlert.mobile
          ? { ...item, ...alertData }
          : item
      ));
    }
  };

  // Column definitions
  const columns = [
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="d-flex gap-1 justify-content-center">
          <Button 
            size="sm" 
            className="btn-outline-primary-custom"
            title="Edit"
            style={{
              padding: '0.25rem 0.5rem'
            }}
            onClick={() => handleEditAlert(row)}
          >
            <i className="bi bi-pencil"></i>
          </Button>
        </div>
      )
    },
    { key: 'apiProvider', label: 'API Provider' },
    { key: 'thresholdAmount', label: 'Threshold Amount' },
    { key: 'currentBalance', label: 'Current Balance' },
    { key: 'mobile', label: 'Mobile Number' },
    { key: 'email', label: 'Email' }
  ];

  return (
    <Container fluid className="p-4">
      <SettingsTable
        data={data}
        settingsType="Low Balance Alert"
        columns={columns}
        onAdd={handleAddAlert}
      />
      <LowBalanceAlertModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        mode={modalMode}
        alertData={selectedAlert}
        onSave={handleSaveAlert}
      />
    </Container>
  );
};

export default LowBalanceAlert;

